import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { DeviceScreenFamilyService } from '@core/services/device-screen-family/device-screen-family.service';
import { NgClass } from '@angular/common';

@Component({
  selector: 'ln-main-menu-buton',
  imports: [NgClass],
  templateUrl: './main-menu-buton.component.html',
  styleUrl: './main-menu-buton.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainMenuButonComponent {
  @Input() label = '';
  @Output() clicked = new EventEmitter<void>();
  private deviceScreenFamily = inject(DeviceScreenFamilyService);
  protected currentScreenSize = this.deviceScreenFamily.currentDeviceScreenFamily;

  onClicked() {
    this.clicked.emit();
  }
}
